import Cookies from "js-cookie";
import {API_HOST} from "config/_entrypoint";
import {sessionStore} from "utils/sessionStore";

const TIMEOUT_MS = 2000;

function currentToken() {
    const stored = sessionStore.get("token");
    if (stored) return stored;
    const cookie = Cookies.get("_f");
    if (!cookie) return null;
    try {
        return JSON.parse(cookie.toString());
    } catch (e) {
        return null;
    }
}

// Tells the API to revoke the current access token so it stops working once
// the user is logged out, instead of staying valid until its expiration.
// Never throws and never blocks the logout for more than TIMEOUT_MS.
export async function revokeApiToken(fetchFn = global.fetch) {
    const token = currentToken();
    if (!token) return false;

    const request = fetchFn(new URL("/logout", API_HOST).toString(), {
        method: "POST",
        headers: {Authorization: "Bearer " + token},
        keepalive: true,
    }).then(response => response.ok);

    const timeout = new Promise(resolve => setTimeout(() => resolve(false), TIMEOUT_MS));

    try {
        return await Promise.race([request, timeout]);
    } catch (e) {
        return false;
    }
}
